
import { Flex, Box} from '@chakra-ui/react';


function Footer(){
    return(
      <Box position={'sticky-bottom'} textAlign={"center"} h={'150px'} w={'full'} bg={'black'} >
        <Flex justifyContent={'center'}>
            <Box m={'5'} textColor={'white'}>
                ADES TEAM 5
            </Box>
        </Flex>
        <Box textColor={'white '} >
          Eclothes ©
        </Box>
        <Box m={'5'} textColor={'white '} >
          Working in Progress
        </Box>


      </Box>
  );
} 


export default Footer;